<template>
  <v-row no-gutters class="align-center">
    <v-col cols="12" sm="3" class="details-label">
      <!-- Allow slot for complex labels or fallback to prop -->
      <slot name="label">{{ label }}</slot>
    </v-col>
    <v-col cols="12" sm="9" class="details-value">
      <!-- Default slot for the value content -->
      <slot>{{ value }}</slot>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ApprovalDetailRow',
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    }
  }
}
</script>
